import { Skeleton } from '@/components/ui/skeleton'

export const UVPSkeleton = () => (
	<div className="animate-fade-in mb-8 grid flex-grow grid-cols-2 gap-4">
		<Skeleton className="h-20 w-full" />
		<Skeleton className="h-20 w-full" />
		<Skeleton className="col-span-1 h-32 w-full" />
		<Skeleton className="col-span-1 h-32 w-full" />
	</div>
)

export default UVPSkeleton
